<script setup>
import { computed, ref } from 'vue';
import IFastBuyModal from '@components/IFastBuyModal/IFastBuyModal.vue';
import EventItemsSkeleton from '@components/EventItemsSkeleton.vue';
import CartItem from './components/CartItem.vue';
import { useCartDataProvider } from '../../hooks/useCartDataProvider.js';
import useCartStore from '../../store/modules/cart.js';

const cartStore = useCartStore();
const { isGuest } = useCartDataProvider();

const orders = computed(() => cartStore.getCart.value);
const loadingCart = ref(true);
cartStore.loadCart().finally(() => (loadingCart.value = false));
</script>

<template>
  <div class="lk">
    <div class="lk__top">
      <a href="/" class="lk__button reset-btn">
        <svg width="20" height="20">
          <use xlink:href="#back" />
        </svg>
        <span>Назад к афише</span>
      </a>
      <h1 class="lk__title">Корзина</h1>
      <button v-if="orders.length" class="lk__clear-card" @click="cartStore.clearCart">
        <span>Очистить корзину</span>
        <svg width="20" height="20">
          <use xlink:href="#basket" />
        </svg>
      </button>
      <div v-else />
    </div>
    <EventItemsSkeleton v-model="loadingCart">
      <div v-if="orders.length" class="order">
        <CartItem v-for="order in orders" :key="order.id" :order="order" />
      </div>

      <div v-if="!orders.length" class="lk__empty">
        <div class="lk__small-title">Корзина пуста</div>
        <p>Ваша корзина пуста. Совершите покупку билета на матч!</p>
        <a href="/" class="lk__button btn reset-btn">Перейти к афише</a>
      </div>
    </EventItemsSkeleton>
  </div>
  <IFastBuyModal v-if="isGuest" v-model="cartStore.isShowFastBuyModal.value" />
</template>
